import { AnswerResultComponent } from "../components/results/answer-result/answer-result.component"
import { CatalogueResultComponent } from "../components/results/catalogue-result/catalogue-result.component"
import { DocumentsResultComponent } from "../components/results/documents-result/documents-result.component"
import { FormationResultComponent } from "../components/results/formation-result/formation-result.component"
import { LexiqueResultComponent } from "../components/results/lexique-result/lexique-result.component"
import { RessourcesResultComponent } from "../components/results/ressources-result/ressources-result.component"
import { UsersResultComponent } from "../components/results/users-result/users-result.component"


export function getClassName(component: string) {
  switch (component) {
    case 'ressources':
      return RessourcesResultComponent
    case 'catalogue':
      return CatalogueResultComponent
    case 'users':
      return UsersResultComponent
    case 'lexique':
      return LexiqueResultComponent
    case 'documents':
      return DocumentsResultComponent
    case 'answer':
      return AnswerResultComponent
    default:
      console.error("Unknown component View")
      // this is empty components we don't use it
      return FormationResultComponent;
  }
}
